
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Send, RefreshCw } from "lucide-react";

interface ChatInputProps {
  input: string;
  setInput: (value: string) => void;
  handleSendMessage: (e: React.FormEvent) => Promise<void>;
  handleRetry: () => void;
  isLoading: boolean;
  networkError: boolean;
  retryAttempt: number;
  hasLastMessage: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({
  input,
  setInput,
  handleSendMessage,
  handleRetry,
  isLoading,
  networkError,
  retryAttempt,
  hasLastMessage
}) => {
  return (
    <div className="flex flex-col gap-2 mt-4">
      {retryAttempt > 0 && !isLoading && (
        <div className="flex justify-center">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleRetry}
            className="flex items-center gap-1"
            disabled={isLoading || networkError}
          >
            <RefreshCw className="h-3 w-3" />
            Retry last message
          </Button>
        </div>
      )}
      
      <form onSubmit={handleSendMessage} className="flex gap-2">
        <Input 
          placeholder="Type your question here..." 
          value={input} 
          onChange={e => setInput(e.target.value)} 
          disabled={isLoading || networkError} 
          className="flex-1" 
        />
        <Button 
          type="submit" 
          size="icon" 
          disabled={isLoading || networkError || (!input.trim() && !hasLastMessage)}
        >
          <Send className="h-5 w-5" />
          <span className="sr-only">Send message</span>
        </Button>
      </form>
    </div>
  );
};

export default ChatInput;
